import { useEffect, useState } from "react";
import { checkAdoRepoAccess } from "../../Api/ado.api";
import { useDataAccessContext } from "../../Contexts/DataAccessContext";

/**
 * Custom hook to check if the signed-in user has access to the AzureUX-Experimentation ADO repo.
 * Returns an object with `hasAccess` and `loading` properties.
 */
export function useCheckRepoAccess() {
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const { setHasAdoAccess } = useDataAccessContext();

  useEffect(() => {
    checkAdoRepoAccess()
      .then((access) => {
        setHasAccess(access);
        setHasAdoAccess(access);
      })
      .catch(() => {
        setHasAccess(false);
        setHasAdoAccess(false);
      })
      .finally(() => setLoading(false));
  }, [setHasAdoAccess]);

  return {
    hasAccess,
    loading,
  };
}
